import pdfIcon from "@/assets/pdf.svg";
import wordIcon from "@/assets/word.svg";
import jpgIcon from "@/assets/jpg.svg";
import pngIcon from "@/assets/png.svg";
import excelIcon from "@/assets/excel.svg";
import unknownIcon from "@/assets/file-unknown.svg";


export const FileTableView = (props) => {
    const {files, breadCrumb} = props;
    //const files = [];

  const getFileIcon = (extension) => {
    if (extension == "pdf") {
      return pdfIcon;
    } else if (extension == "jpg" || extension == "jpeg") {
      return jpgIcon;
    } else if (extension == "png") {
      return pngIcon;
    } else if (extension == "xlsx" || extension == "xls") {
      return excelIcon;
    } else if (extension == "docx" || extension == "doc") {
      return wordIcon;
    } else {
      return unknownIcon;
    }
  }

  return (
    <>
        <div className="ppc-px-2 sm:ppc-px-6 lg:ppc-px-8">
      <div className="sm:ppc-flex sm:ppc-items-center">
        <div className="sm:ppc-flex-auto">


        </div>
      </div>
      <div className="ppc-flow-root">
        <div className="-ppc-mx-4 -ppc-my-2 ppc-overflow-x-auto sm:-ppc-mx-6 lg:-ppc-mx-8">
          <div className="ppc-inline-block ppc-min-w-full ppc-py-2 ppc-align-middle sm:ppc-px-6 lg:ppc-px-8">
            <table className="ppc-min-w-full ppc-divide-y ppc-divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="ppc-py-3.5 ppc-pl-4 ppc-pr-3 ppc-text-left ppc-text-sm ppc-font-semibold ppc-text-gray-900 sm:ppc-pl-0">
                    Name
                  </th>
                  <th scope="col" className="ppc-px-3 ppc-py-3.5 ppc-text-left ppc-text-sm ppc-font-semibold ppc-text-gray-900">
                    Grootte
                  </th>
                </tr>
              </thead>
              <tbody className="ppc-divide-y ppc-divide-gray-200 ppc-bg-white">
                {files.map((file) => (
                  <tr className="ppc-cursor-pointer" key={file.id} onClick={(event) => props.onSelectFileHandler(event, file)}>
                    <td className="ppc-whitespace-nowrap ppc-py-5 ppc-pl-4 ppc-pr-3 ppc-text-sm sm:ppc-pl-0">
                      <div className="ppc-flex ppc-items-center">
                        <div className="ppc-h-11 ppc-w-11 ppc-flex-shrink-0">
                          <img className="ppc-h-11 ppc-w-11 ppc-rounded-full" src={getFileIcon(file.extension)} alt="" />
                        </div>
                        <div className="ppc-ml-4">
                          <div className="ppc-font-medium ppc-text-gray-900">{file.filename}</div>
                          <div className="ppc-mt-1 ppc-text-gray-500">{file.extension}</div>
                        </div>
                      </div>
                    </td>
                    <td className="ppc-whitespace-nowrap ppc-px-3 ppc-py-5 ppc-text-sm ppc-text-gray-500">
                      <div className="ppc-text-gray-900">{file.size}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}